import { render, staticRenderFns } from "./CancellationNotice.vue?vue&type=template&id=54ba0860&scoped=true&"
import script from "./CancellationNotice.vue?vue&type=script&lang=js&"
export * from "./CancellationNotice.vue?vue&type=script&lang=js&"
import style0 from "./CancellationNotice.vue?vue&type=style&index=0&id=54ba0860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba0860",
  null
  
)

export default component.exports